declare var swal: any;
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../services/spinner.service';
import { AppData } from '../../../models/appdata';
import { ApiResponseModel } from '../../../models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';


import { ActorService } from '../../../services/actor.service';
import { DBOperation } from '../../../enums/enum';

import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { HCPService } from '../../../services/hcp.service';
import { ActorEducationInfoRequest, ActorEducationInfoController, ServiceBranchMapByFormattedCodeRequest } from '../../../models/profileinfo/profileinfo.model';
//import { NgbEducationInfoModal } from '../../educationinfo/modals/educationinfo.modal';
//import { NgbActorDocsModal } from '../../modals/actordocs/actordocs.modal';
//import * as moment from 'moment';
import { CustomDateTimeService } from '../../../services/datetime.service';


import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { NGXToastrService } from '../../../../shared/services/toastr.service';
import {
  ShiftAllocPatternRequest, CareUnitInfoRequest, ParentCareUnitsInfoController, CareUnitByParentCodeInfoController, ShiftTypeInfoRequest,
  ShiftTypeInfoController, StaffTypeInfoRequest, StaffTypeInfoController, MasterH2RContractAddRequest, MasterH2RContractGetRequest, MasterH2RContractController
} from '../../../models/hcare/hcare.model';
import { HcareService } from '../../../services/hcare.service';
import { FaciliesInfoByTypeController, FacilitiesInfoByTypeRequest, ServiceCategoriesController, ServiceCategoriesRequest, ServicesByCategoryCodeController, ServicesByCategoryCodeRequest, ServiceDetailsByCodeRequest, ServiceDetailsByCodeController, GenericProcPostRequest, ServicesByCategoryCodeController2, GetServicesRequest, S_Methods } from '../../../models/actor/actor';

import { NgbAddServiceModal } from './view-general/modal/addservice.modal';
import { NgbAddCategoryModal } from './modals/addcategory.modal';
import { NgbEditCategoryModal } from './modals/editcategory.modal';
import { Pipe } from '@angular/core';
import { Injectable } from '@angular/core';
import { PipeTransform } from '@angular/core';
import { ServiceCategoryPipe } from '../../../pipes/actors/actorIdentity.pipes';
import { ServiceConfigurationInfoPipe } from './service.component';
import { NgbEditServicesModal } from '../profile/patientprofileview/personaldetailview/modal/editservices.modal';
import { NgbAddNewServiceModal } from '../profile/patientprofileview/personaldetailview/modal/addnewservice.modal';
import { NgbFacilitywise_ProviderCostModal } from '../follow up/counsellingregistry/modal/facilitywise_providercost.modal';


//@Pipe({
//  name: 'serviceconfigurationpipe'
//})

//@Injectable()
//export class ServiceConfigurationInfoPipe implements PipeTransform {

//  transform(value: ServiceCategoriesController[], filter: string): ServiceCategoriesController[] {
//    filter = filter ? filter.toLocaleLowerCase() : null;
//    return filter ? value.filter((app: ServiceCategoriesController) =>
//      app.CategoryName != null && app.CategoryName.toLocaleLowerCase().indexOf(filter) != -1
     

//    ) : value;
//  }

//}
//@Pipe({
//  name: 'serviceconfigurationpipe2'
//})

//@Injectable()
//export class ServiceConfigurationInfoPipe2 implements PipeTransform {

//  transform(value: ServicesByCategoryCodeController[], filter2: string): ServicesByCategoryCodeController[] {
//    filter2 = filter2 ? filter2.toLocaleLowerCase() : null;
//    return filter2 ? value.filter((app: ServicesByCategoryCodeController) =>
//      app.Code != null && app.Code.toString().toLocaleLowerCase().indexOf(filter2) !=-1||
//      app.ServiceName != null && app.ServiceName.toLocaleLowerCase().indexOf(filter2) != -1


//    ) : value;
//  }

//}

@Component({
  selector: 'servicespanel',
  templateUrl: './servicespanel.component.html',
  styleUrls: ['./servicespanel.component.scss']
})

export class  ServicesPanelComponent implements OnInit {

  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
  searchTitle: string;

  constructor(private router: Router,
    private hcareservice: HcareService,
    private actorservice: ActorService,
    private route: ActivatedRoute, private loaderService: SpinnerService, private hcpservice: HCPService,
    private modalService: NgbModal, private filter: ServiceConfigurationInfoPipe, private filter2: ServiceCategoryPipe, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService) { } 


  ngOnInit() {
    this.GetServices();

  }
  CurrentServicesByCategoryCodeController2: ServicesByCategoryCodeController2[];
  GetServices() {
    var getReq = new GetServicesRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    getReq.ConditionalOperator = 101010;
    getReq.SearchText = "";
    getReq.FacilityCode = AppData.Instance().SelectedBranchCode;
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101010;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {

        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var rawData: any = this.ApiResData.Result;
          if (Array.isArray(rawData) && rawData.length > 0 && typeof rawData[0] === 'object') {
            // New backend: Result is already an array of objects
            this.CurrentServicesByCategoryCodeController2 = rawData;
          } else if (Array.isArray(rawData)) {
            // Old style: array of strings joined into JSON
            var data: string = rawData.join("");
            this.CurrentServicesByCategoryCodeController2 = JSON.parse(data);
          } else {
            this.CurrentServicesByCategoryCodeController2 = [];
          }
          if (this.CurrentServicesByCategoryCodeController2 && this.CurrentServicesByCategoryCodeController2.length > 0) {
            this.stopRefreshing();
          } else {
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  RefreshServices(st: string) {
    var getReq = new GetServicesRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    getReq.ConditionalOperator = 101010;
    getReq.SearchText = st;
    getReq.FacilityCode = AppData.Instance().SelectedBranchCode;
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101010;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {

        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var rawData: any = this.ApiResData.Result;
          if (Array.isArray(rawData) && rawData.length > 0 && typeof rawData[0] === 'object') {
            // New backend: Result is already an array of objects
            this.CurrentServicesByCategoryCodeController2 = rawData;
          } else if (Array.isArray(rawData)) {
            // Old style: array of strings joined into JSON
            var data: string = rawData.join("");
            this.CurrentServicesByCategoryCodeController2 = JSON.parse(data);
          } else {
            this.CurrentServicesByCategoryCodeController2 = [];
          }
          if (this.CurrentServicesByCategoryCodeController2 && this.CurrentServicesByCategoryCodeController2.length > 0) {
            this.stopRefreshing();
          } else {
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  criteriaChange(value: string) {
    this.RefreshServices(value);

  }
  AddNewService() {
    const modalRef = this.modalService.open(NgbAddNewServiceModal,
      {
        centered: true,
        size: "lg",
        backdrop: 'static',
        keyboard: false
      })
    modalRef.result.then(x => { this.GetServices() })
  }
  edit(l: ServicesByCategoryCodeController2) {

    const modalRef = this.modalService.open(NgbEditServicesModal,
      {
        centered: true,
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.Code = l.Code;
    modalRef.componentInstance.CategoryName = l.CategoryName;
    modalRef.componentInstance.ServiceCategory = l.Servicecategory;
    modalRef.componentInstance.BasePrice = l.BasePrice;
    modalRef.componentInstance.ServiceName = l.ServiceName;
    modalRef.componentInstance.RevenueCategory = l.RevenueCategory;
    modalRef.componentInstance.ServiceType = l.ServiceType;
    modalRef.componentInstance.DepartmentCode = l.DepartmentCode; 
    modalRef.componentInstance.DepartmentName = l.DepartmentName;
    modalRef.componentInstance.BranchBasePrice = l.BranchBasePrice;
    modalRef.componentInstance.SelectedFacilityCodeOld = AppData.Instance().SelectedBranchCode;
    modalRef.result.then(x => { this.GetServices() })

  } 
  svc_provider(l: ServicesByCategoryCodeController2) {

    const modalRef = this.modalService.open(NgbFacilitywise_ProviderCostModal,
      {
        centered: true,
        size: "lg",
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.CurrentServicesByCategoryCodeController2 = l;
    modalRef.result.then(x => { this.GetServices() })
    //modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
    //  l.ProviderName = receivedEntry.make;
    //  l.ProviderCode = receivedEntry.value;
    //  l.UnitPrice = receivedEntry.number;
    //})

  } 
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}
